module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-expansion-panels', _vm._l((_vm.info), function(item, i) {
    return _c('v-expansion-panel', {
      key: i
    }, [_c('v-expansion-panel-header', {
      staticClass: "font-weight-bold"
    }, [_vm._v("\n            " + _vm._s(item.question) + "\n        ")]), _vm._v(" "), _c('v-expansion-panel-content', [_vm._v("\n            " + _vm._s(item.answer) + "\n            "), (item.question === 'Apa itu level pada ambis meter?') ? _c('div', {
      staticClass: "mt-5"
    }, _vm._l((_vm.level), function(data, i) {
      return _c('v-card', {
        key: i,
        staticClass: "mb-5 pt-5"
      }, [_c('div', {
        staticClass: "d-flex flex-no-wrap pl-5"
      }, [_c('v-avatar', {
        attrs: {
          "size": "75",
          "tile": ""
        }
      }, [_c('v-img', {
        attrs: {
          "src": data.badge
        }
      })], 1), _vm._v(" "), _c('v-card-subtitle', [_vm._v(_vm._s(data.description))])], 1), _vm._v(" "), _c('v-card-title', {
        staticClass: "text-h5 pl-7"
      }, [_vm._v(_vm._s(data.name))])], 1)
    }), 1) : _vm._e()])], 1)
  }), 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-62670f4f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/ambis_meter/components/InfoPage.vue
// module id = 986
// module chunks = 1